



























// @ts-ignore
import v8n from 'v8n';
import { Component, Prop, Vue, Watch, Model } from 'vue-property-decorator';
import { ApiError, LongTermRate } from '@/api';
import { snackModule } from '@/store';
import CurrencyField from '@/components/CurrencyField.vue';

@Component({
  components: { CurrencyField },
})
export default class extends Vue {
  valid: boolean = false;
  loading: boolean = false;

  rates: LongTermRate[] = [];

  requiredString = [
    (v: string) =>
      v8n()
        .string()
        .not.empty()
        .test(v) || 'This field is required',
  ];

  async save() {
    if (!this.rates) {
      return;
    }

    try {
      this.loading = true;
      await Promise.all(
        this.rates.map(rate => {
          rate.save();
        }),
      );
      snackModule.showSnackbar('Rates Updated');
    } catch (err) {
      err.response.errors.forEach((e: ApiError) =>
        snackModule.showSnackbar(e.detail),
      );
    } finally {
      this.loading = false;
    }
  }

  async mounted() {
    try {
      this.rates = (await LongTermRate.includes(['lot']).all()).data;
    } catch (err) {
      // most likely this means not found
      snackModule.showSnackbar('Rates not found');
    }
  }
}
